import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/", { replace: true, state: { from: location.pathname } });
    } else {
      setChecked(true);
    }
  }, [user, loading, navigate, location.pathname]);

  if (loading || !checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1115]">
        <div className="pp-label" data-testid="protected-loading">
          Verifying session…
        </div>
      </div>
    );
  }
  return children;
}
